import type { StarTrack } from '@/app/common/starTrack/startrack.ts';
import { createResultShownPayload } from '@/app/common/starTrack/events/resultShown.ts';
import { ampliResultShown } from '@/app/common/amplitude/events/ampliResultShown.ts';
import type { SearchInfoData } from '@/app/search/types.ts';
import { createOffsetFromPage } from '@/app/components/search/utils/pagerUtils.ts';
import type { SearchParams } from '@/server/searchParams.ts';
import type { ProductsData } from '@/app/api/search/products/createProductsData.ts';
import type { ListViewType } from '@/app/common/viewModeUtils.ts';
import type { Localization } from '@/app/components/search/common/Localization.ts';
import type { CommonData } from '@/app/common/createCommonData.ts';
import { URLParameters } from '../urlParameters';

type TrackingResultShownProps = {
  starTrack: StarTrack;
  searchParams: SearchParams;
  searchInfoData: SearchInfoData;
  listView: ListViewType;
  productsData: ProductsData;
  commonData: CommonData;
  localization: Localization;
};
export const trackingResultShown = ({
  starTrack,
  searchParams,
  searchInfoData,
  listView,
  productsData,
  commonData,
  localization,
}: TrackingResultShownProps) => {
  const { searchId } = searchInfoData;
  const { dealCards } = productsData;
  const offset = createOffsetFromPage(searchParams[URLParameters.PAGE]);

  starTrack.resultShown(createResultShownPayload({ searchId, offset, dealCards, listView, localization }));

  ampliResultShown({
    searchParams,
    searchInfoData,
    dealCards,
    listView,
    commonData,
    localization,
  });
};
